import { get } from './apiClient';
import { RawSit, UISit } from './types';
import { mapSit } from './mapper';

export const sitsService = {
  async list(): Promise<UISit[]> {
    const { data } = await get<RawSit[]>('/sits');
    return data.map(mapSit);
  },
};
